import { ArrowRight, Link2, Cpu, Smartphone } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const STEPS = [
  {
    n: "01",
    icon: Link2,
    title: "Tell Us Where Reviews Should Go",
    body: "During checkout, provide your business's Google review URL.",
  },
  {
    n: "02",
    icon: Cpu,
    title: "We Configure Your Products",
    body: "Each physical product receives its own unique Revora identity and is configured to route customers to your review page.",
  },
  {
    n: "03",
    icon: Smartphone,
    title: "Customers Tap & Review",
    body: "Place your Revora products where customers interact with your business. One tap of the phone takes them straight to your review page.",
  },
];

export const Steps = () => (
  <section className="bg-white py-28 sm:py-36" data-testid="steps-section">
    <div className="max-w-7xl mx-auto px-6">
      <Chapter number="03" label="The Process" />
      <div className="grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <h2 className="rvr-title font-display text-4xl md:text-5xl font-bold tracking-tight text-ink leading-[1.05]">
            Configured for your business. <span className="text-voltdark">Before it ships.</span>
          </h2>
          <div className="mt-10 flex flex-wrap items-center gap-3 text-sm font-bold" data-testid="flow-diagram">
            <span className="bg-ink text-white px-5 py-2.5 rounded-full">Your Business</span>
            <ArrowRight className="w-4 h-4 text-voltdark" />
            <span className="bg-volt text-ink px-5 py-2.5 rounded-full">Revora</span>
            <ArrowRight className="w-4 h-4 text-voltdark" />
            <span className="border border-black/15 px-5 py-2.5 rounded-full text-ink">Your Customer's Review Page</span>
          </div>
        </Reveal>
        <div className="lg:col-span-7 space-y-0">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <div className="group flex gap-8 py-8 border-t border-black/10 last:border-b items-start" data-testid={`step-${s.n}`}>
                <span className="font-display text-5xl font-black text-black/10 group-hover:text-voltdark transition-colors duration-300 leading-none">
                  {s.n}
                </span>
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <s.icon className="w-5 h-5 text-voltdark" />
                    <h3 className="font-display text-xl font-bold text-ink">{s.title}</h3>
                  </div>
                  <p className="text-black/55 leading-relaxed max-w-md">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
